import styled from '@emotion/styled'
import { breakpoint, calcRem } from '../../../__styling'

const stayInformedBackground = require('../assets/stay-informed-background.webp')
const twLogo = require('../assets/W.svg')

export const TWStayInformedBlockContainer = styled.div(() => ({
    padding: calcRem(48, 0),
    background: `url(${twLogo}) right bottom / 50% auto no-repeat, rgba(0, 4, 46, 1)`,
    alignItems: 'center',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: calcRem(32),

    [breakpoint('xs')]: {
        backgroundImage: `url(${stayInformedBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    },

    [breakpoint('sm')]: {
        padding: calcRem(64, 0),
        gap: calcRem(32),
    },
}))

export const TWStayInformedContent = styled('div')(({ theme }) => ({
    padding: calcRem(0, 16),
    width: '100%',
    maxWidth: 1044,
    boxSizing: 'border-box',
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: calcRem(16),

    [breakpoint('xs')]: {
        padding: calcRem(0, 32),
    },
}))

export const StyledHeader = styled('h2')(({ theme }) => ({
    color: 'white',
    fontFamily: theme.fonts.heading,
    fontWeight: 400,
    textAlign: 'center',
    fontSize: calcRem(28),
    lineHeight: calcRem(36),
    margin: 0,
    padding: 0,
}))

export const StyledSubText = styled('p')(({ theme }) => ({
    color: 'white',
    fontFamily: theme.fonts.sansSerif,
    fontWeight: 400,
    fontSize: calcRem(18),
    lineHeight: calcRem(28),
    textAlign: 'center',
    margin: 0,
    padding: 0,
}))

export const TWAppDownloadWidgetContainer = styled('div')({
    padding: calcRem(0, 16),
    maxWidth: 1044,
    boxSizing: 'border-box',
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    [breakpoint('xs')]: {
        padding: calcRem(0, 32),
    },
})
